module.exports = __webpack_public_path__ + "img/icon-line-color.7a336c18.svg";